export const routesPath = {
  login: 'login',
  inicio: 'inicio',
  clientes: {
    base: 'clientes',
    listar: 'listar',
    editar: 'editar/:id'
  },
  contactos: {
    base: 'contactos',
    listar: 'listar'
  },
  hosting: {
    base: 'hosting',
    listar: 'listar'
  },
  dominios: {
    base: 'dominios',
    contratados: {
      internacional: {
        listar: 'contratados/internacional/listar'
      }
    }
  }
};

export const apiPath = {
  clientes: {
    base: 'clientes'
  },
  contactos: {
    base: 'contactos'
  },
  hosting: {
    reseller: {
      base: 'hosting/reseller'
    },
    sistema: {
      paquetes: 'hosting/sistema/paquetes'
    }
  },
  dominios: {
    contratados: {
      internacional: {
        base: 'dominios/reseller/contratados/internacional'
      }
    }
  },
  sistema: {
    catalogos: {
      base: 'sistema/catalogos'
    }
  }
}